import { useRef } from 'react';
import { Outlet } from 'react-router-dom';
import styled from 'styled-components';
import { useLayoutState } from '../../../provider/LayoutProvider';
import { CompanyInfo } from '../bottom/CompanyInfo';
import { BottomNavigator } from '../fixedFooter/BottomNavigator/BottomNavigator';
import { DownloadAppModal } from '../modal/popup/DownloadAppModal';

export const AppLayout = () => {
  const { fixedHeader, fixedHeaderHeight, fixedFooter, fixedFooterHeight, shouldShowFooter, style } = useLayoutState();
  const mainRef = useRef<HTMLElement>(null);

  return (
    <BaseLayout>
      <FixedHeaderSection>
        <DownloadAppModal />
        {fixedHeader ?? <></>}
      </FixedHeaderSection>

      <ScrollableSection>
        <MainContentSection
          style={{
            ...style,
            paddingTop: `${fixedHeaderHeight ?? 0}px`,
            paddingBottom: `${fixedFooterHeight ?? 0}px`,
          }}
        >
          <MainContent ref={mainRef}>
            <Outlet />
          </MainContent>
        </MainContentSection>

        {shouldShowFooter ? (
          <SubContentSection>
            <CompanyInfo />
          </SubContentSection>
        ) : null}
      </ScrollableSection>

      <FixedFooterSection className={'bg-white/75 shadow-inner'}>
        <BottomNavigator />
        {fixedFooter ?? <></>}
      </FixedFooterSection>
    </BaseLayout>
  );
};

const BaseLayout = styled.div`
  background-color: white;
`;

const FixedHeaderSection = styled.header`
  width: 100%;
  max-width: 512px;

  position: fixed;

  top: 0px;
  left: auto;
  right: auto;

  padding-bottom: 0px;
  background-color: white;

  z-index: 55;
`;

const MainContentSection = styled.div`
  width: 100vw;
  max-width: 512px;
  min-height: 100vh;
`;

const MainContent = styled.main`
  width: 100%;
  height: 100%;

  box-sizing: border-box;
`;

const FixedFooterSection = styled.div`
  width: 100%;
  max-width: 512px;

  display: block;
  position: fixed;

  bottom: 0px;
  left: auto;
  right: auto;

  z-index: 100;

  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
`;

const SubContentSection = styled.footer`
  box-sizing: border-box;
`;

const ScrollableSection = styled.div`
  display: flex;
  flex-direction: column;
`;
